import { useMutation } from "@tanstack/react-query";

import { handleSearchParams } from "@/api/handleSearchParams";
import { API_URL } from "@/constants/envVariables";
import { SESSION_EXPIRED_EVENT } from "@/constants/settings";
import { fetchApi } from "@/helpers/fetchApi";
import { getFilenameFromContentDisposition } from "@/helpers/getFilenameFromContentDisposition";
import { normalizeApiError } from "@/helpers/normalizeApiError";
import { saveFile } from "@/helpers/saveFile";
import { AppError, MultisigAuditLogSearchParams } from "@/types";

export const useMultisigAuditLogExport = () => {
  return useMutation<void, AppError, MultisigAuditLogSearchParams>({
    mutationFn: async (params) => {
      const searchParams = handleSearchParams(params);

      await fetchApi(
        `${API_URL}/multisig/audit-log/export${searchParams}`,
        {},
        {
          customCallback: async (response: Response) => {
            if (response.status === 401) {
              document.dispatchEvent(new CustomEvent(SESSION_EXPIRED_EVENT));
              return;
            }
            if (!response.ok) {
              const err = await response.json().catch(() => ({}));
              throw normalizeApiError(err);
            }

            const blob = await response.blob();
            const fallback = "multisig-audit-log.csv";
            const filename = getFilenameFromContentDisposition(
              response.headers.get("Content-Disposition"),
              fallback,
            );
            saveFile({
              file: new File([blob], filename, { type: "text/csv" }),
              suggestedFileName: filename,
            });
          },
        },
      );
    },
  });
};